import { Record } from "immutable"

import { updateCreateModel } from "../model-utils"

const tagFields = ["types", "statuses"]

export const InsightAreaFilterModel = new Record({
    name: "",
    types: [],
    statuses: [],
    empty: false
})

export const updateInsightAreaSearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) =>
    updateCreateModel(
        name,
        value,
        searchFilterModel,
        workingFilterModel,
        tagFields
    )
